export default __webpack_public_path__ + "static/media/map-pin.81952ada.svg";